<template>
  <div>
    <div class="fullview">
      <div class="loading-spacer" />
      <vue-loading
        type="spin"
        color="#b2cbe4"
        :size="{ width: '200px', height: '200px' }"
      />
    </div>
  </div>
</template>

<script>
import { VueLoading } from 'vue-loading-template'

export default {
  name: 'Loading',
  components: {
    VueLoading
  }
}
</script>

<style>
.fullview {
  width: 100%;
  height: 100%;
  background: #fefefe;
  position: fixed;
  top: 0;
  left: 0;
}
.loading-spacer {
  height: 30%;
}
</style>
